import type { ItemOption } from '@yoop/server-model/inventory-category';
import type { CategoryDetailResponse } from '@yoop/server-model/inventory-category';
import type { SeatConfigurationType } from '@yoop/server-model/seating';
import type { InventoryItemSeatingData, TokenPrice } from '@yoop/server-model/token-info';

export enum PayoutType {
  PAYPAL = 'PAYPAL',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
}

export interface PayoutMethodResponse {
  id: number;
  type: PayoutType;
  username: string;
  status: PayoutMethodStatus;
}

export enum PayoutMethodStatus {
  LAST_ATTEMPT_FAILED = 'LAST_ATTEMPT_FAILED',
}

export enum PayoutStatus {
  PENDING = 'PENDING',
  INITIATED = 'INITIATED',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export interface ResaleInventoryItem {
  inventoryItemId: number;
  parentInventoryItemId?: number;
  soldDate?: string;
  /**
   * @deprecated use inventoryItemSeatingData instead
   */
  row: string;
  /**
   * @deprecated use inventoryItemSeatingData instead
   */
  rowCode: string;
  /**
   * @deprecated use inventoryItemSeatingData instead
   */
  seat: string;
  /**
   * @deprecated use inventoryItemSeatingData instead
   */
  seatCode: string;
  /**
   * @deprecated use inventoryItemSeatingData instead
   */
  section: string;
  /**
   * @deprecated use inventoryItemSeatingData instead
   */
  sectionCode?: string;
  inventoryItemSeatingData?: InventoryItemSeatingData;
  accessed?: boolean;
  offerGroupSellerUserId?: number;
  offerGroupSellerGlobalUserId?: string;
}

// TODO: [Token Choices Refactor] - Not a server model, move out
export interface ResaleItem extends ResaleInventoryItem {
  categoryDetail: CategoryDetailResponse;
  choiceData?: ItemOption[];
  seatConfigurationType: SeatConfigurationType;
}

export interface ResaleOfferGroup {
  description: string;
  id: number;
  categoryDetailResponse: CategoryDetailResponse;
  payoutStatus: PayoutStatus;
  reservePrice: number;
  seatConfigurationType: SeatConfigurationType;
  payoutMethod: PayoutMethodResponse;
  payoutReceipt: TokenPrice;
  soldInventoryItems: ResaleInventoryItem[];
  unsoldInventoryItems: ResaleInventoryItem[];
  fineprint: string;
}
